import { HomeBanner } from '../components/home/HomeBanner'
import { HomeFeatures } from '../components/home/HomeFeatures'
import { HomeProcess } from '../components/home/HomeProcess'
import { HomePainPoints } from '../components/home/HomePainPoints'
import { HomeTraceability } from '../components/home/HomeTraceability'

export function HomePage() {
  return (
    <>
      <HomeBanner />
      <HomeFeatures />
      <HomeProcess />
      <HomePainPoints />
      <HomeTraceability />
      {/*  <HomeCases /> */}
      {/* <HomeCTA /> */}
    </>
  )
}
